import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../conf/axiosBaseQuery";
import { RealEstateEndpoints } from "../../endpoints/realestate.endpoints";
import { FeatureListValuesQRTK } from "./values/features.value";
import { FeatureResponse } from "./responses/feature.response";
import featureAdapter from "../../../../private/realestate/adapters/feature.adapter";
import { CreateRealestateValuesQRTK } from "./values/create-realestate.value";
import getFormData from "@/src-refactor/modules/shared/helpers/object-to-form-data";
import { PropertyListResponse } from "./responses/property-list.response";
import { HelperCreateQuery } from "@/src-refactor/modules/shared/helpers/create-query.helper";
import { ListPropertiesAdapter } from "../../../../private/realestate/adapters/list-properties.adapter";
import { RealEstateListValuesQRTK } from "./values/list_realestate.value";
import { IPropertyDetailsResponse } from "./responses/property-details.response";
import { RealEstateDetailsValuesRTKQ } from "./values/details.realestate.value";
import { RefererRealestateValuesQRTK } from "./values/referer-realestate.value";
import { ActivateRealestateValuesQRTK } from "./values/activate-realestate.value";
import { DropRealestateValuesQRTK } from "./values/drop-realestate.value";
import { DeleteRealestateValuesQRTK } from "./values/delete-realestate.value";
import { LastChangesRealestateValuesQRTK } from "./values/last-changes-realestate.value";
import { UpdateRealestateValuesQRTK } from "./values/update-realestate.value";
import { SeoWithAiValuesQRTK } from "./values/seo-with-ai.value";
import { ISeoWithAiResponse } from "./responses/seo-with-ai.response";
import { ReportRealestateValuesQRTK } from "./values/report-realestate.value";
import { CheckConflictsRealestateValuesQRTK } from "./values/check-conflicts-realestate.value";
import { GetConflictRealestateValuesQRTK } from "./values/get-conflicts-realestate.value";
import { FeedbackRealestateValuesQRTK } from "./values/feedback-realestate.value";
import featureProjectAdapter from "../../../../private/realestate/adapters/feature-project.adapter";
import { GetAdvanceDataRealestateValuesQRTK } from "./values/get-advace-data-realestate.value";
import { TrustEntitiesResponse } from "./responses/trust-entities.response";
import { GetTranslationValuesQRTK } from "./values/seo-translation.values";
import { ISeoTranslationResponse } from "./responses/seo-translation.response";
import { TranslationV3ValuesQRTK } from "./values/translation-v3.values";
import { ITranslationV3Response } from "./responses/translation-v3.response";
import { ApproveRealestateValuesQRTK } from "./values/approve-document-realestate.value";
import { DeclineRealestateValuesQRTK } from "./values/decline-document-realestate.value";
import {
  IPropertyCheckConflictResponse,
  transformPropertyCheckConflict
} from "./responses/property-check-conflict";
import { mainSplitApi } from "../../mainSplitApi";
import PROPERTY_TAG_TYPES from "./realestate.tags";
import STATS_TAG_TYPES from "../stats/stats.tags";
import HGetFormData from "@rf-helper/create-form-data.helper";
import {
  CreateDraftRealEstateValuesQRTK,
  DeleteDraftRealEstateValuesQRTK,
  draftResponses,
  GetDraftRealEstateValuesQRTK
} from "./values/draft-realestate.value";
import { GETTrustRealEstateValuesQRTK } from "./values/trust-realestate.value";
import {
  RealEstateChangeLogResponseRTKQ,
  RealEstateChangeLogValuesRTKQ
} from "./values/changeLog.realestate.value";
import { PartialActivateRealestateValuesQRTK } from "./values/patial-activate-realestate.value";
import {
  remaxGlobalDetailMock,
  remaxGlobalListMock
} from "@rf/mock/remax_global.mock";
import { UploadImageValuesQRTK } from "./values/upload-image.values";
import { UploadDocumentValuesQRTK } from "./values/upload-document.values";
import { UploadImageByIdValuesQRTK } from "./values/upload-image-by-id.values";
import { UploadDocumentByIdValuesQRTK } from "./values/upload-document-by-id.values";
import { IUploadImageResponse } from "./responses/upload-image.response";
import { IUploadDocumentResponse } from "./responses/upload-document.response";
import { IUploadImageByIdResponse } from "./responses/upload-image-by-id.response";
import { IUploadDocumentByIdResponse } from "./responses/upload-document-by-id.response";
import { GenerateSeoWithChatGptValuesQRTK } from "./values/generate-seo-with-chatgpt.values";
import { IGenerateSeoWithChatGptResponse } from "./responses/generate-seo-with-chatgpt.response";
import { ActivationRequestRealestateValuesQRTK } from "./values/activation-request-realestate.value";

export const RealEstateQueryServices = createApi({
  reducerPath: "RealEstate-services-rf",
  baseQuery: axiosBaseQuery(),

  endpoints: builder => ({
    getFeature: builder.mutation({
      query: (values: FeatureListValuesQRTK) => ({
        url:
          RealEstateEndpoints.GetRealEstateFeatures(values.params?.id) +
          HelperCreateQuery(values.query),
        method: "GET"
      }),
      transformResponse: (response: FeatureResponse, meta, arg) =>
        featureAdapter(response)
    }),
    getFeatureProject: builder.mutation({
      query: (values: FeatureListValuesQRTK) => ({
        url:
          RealEstateEndpoints.GetRealEstateFeatures(values.params?.id) +
          HelperCreateQuery(values.query),
        method: "GET"
      }),
      transformResponse: (response: FeatureResponse, meta, arg) =>
        featureProjectAdapter(response)
    }),

    propertyList: builder.mutation({
      query: (values: RealEstateListValuesQRTK) => ({
        url: RealEstateEndpoints.ListRealEstate + HelperCreateQuery(values.query),
        method: "GET"
      }),
      transformResponse: (response: PropertyListResponse, meta, arg) =>
        ListPropertiesAdapter(response)
    }),

    propertyDetail: builder.mutation({
      query: (values: RealEstateDetailsValuesRTKQ) => ({
        url:
          RealEstateEndpoints.DetailRealEstate(values.params.id) +
          HelperCreateQuery(values.query),
        method: "GET"
      }),
      transformResponse: (response: IPropertyDetailsResponse, meta, arg) => response
    }),

    RefererProperty: builder.mutation({
      query: (values: RefererRealestateValuesQRTK) => ({
        url: RealEstateEndpoints.RefererProperty,
        method: "POST",
        content_type: "application/json",
        body: JSON.stringify(values?.body)
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    }),

    DeleteRealEstate: builder.mutation({
      query: (values: DeleteRealestateValuesQRTK) => ({
        url: RealEstateEndpoints.DeleteRealEstate(values.params.id),
        method: "POST"
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    }),
    ReportRealEstate: builder.mutation({
      query: (values: ReportRealestateValuesQRTK) => ({
        url: RealEstateEndpoints.ReportProperty,
        method: "POST",
        body: getFormData(values.body)
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    }),

    /**
     * @deprecated
     * */
    DropRealEstate: builder.mutation({
      query: (values: DropRealestateValuesQRTK) => ({
        url: RealEstateEndpoints.DropRealEstate(values.params.id),
        method: "POST",
        body: getFormData(values.body)
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    }),
    LastChangesRealEstate: builder.mutation({
      query: (values: LastChangesRealestateValuesQRTK) => ({
        url:
          RealEstateEndpoints.LastChanges(values.params.id) +
          HelperCreateQuery(values.query),
        method: "GET"
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    }),
    GetSeoWithChatGpt: builder.mutation({
      query: (values: SeoWithAiValuesQRTK) => ({
        url:
          RealEstateEndpoints.SeoWithAi +
          HelperCreateQuery(values.query, { encodeArray: true }),
        method: "GET"
      }),
      transformResponse: (response: ISeoWithAiResponse, meta, arg) => {
        return response;
      }
    }),

    getConflicts: builder.mutation({
      query: (values: GetConflictRealestateValuesQRTK) => ({
        url: RealEstateEndpoints.GetConflict(values.params.id),
        method: "GET"
      }),
      transformResponse: (response: any, meta, arg) => {
        return ListPropertiesAdapter({
          data: response.data,
          links: {
            first: "",
            last: "",
            next: "",
            prev: ""
          },
          meta: {
            current_page: 1,
            from: 1,
            last_page: 1,
            path: "",
            per_page: 1,
            to: 1,
            total: 1,
            links: []
          },
          message: ""
        });
      }
    }),

    getAdvanceData: builder.mutation({
      query: (values: GetAdvanceDataRealestateValuesQRTK) => ({
        url: RealEstateEndpoints.getAdvanceData(values.params.id),
        method: "GET"
      }),
      transformResponse(response: any, meta, arg) {
        return response;
      }
    }),
    solveConflicts: builder.mutation({
      query: (values: any) => ({
        url: RealEstateEndpoints.SolveConflict,
        method: "POST",
        body: getFormData(values.body)
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    }),

    sedFeedback: builder.mutation({
      query: (values: FeedbackRealestateValuesQRTK) => ({
        url: RealEstateEndpoints.SendFeedback,
        method: "POST",
        body: values.body
      }),
      transformResponse(response: any, meta, arg) {
        return response;
      }
    }),

    getTrustEntities: builder.mutation({
      query: (values: any) => ({
        url: RealEstateEndpoints.GetTrustEntities,
        method: "GET"
      }),
      transformResponse: (response: TrustEntitiesResponse[], meta, arg) => {
        return response;
      }
    }),

    translateSeo: builder.mutation({
      query: (values: GetTranslationValuesQRTK) => ({
        url: RealEstateEndpoints.SeoTranslation,
        method: "POST",
        body: getFormData(values.body)
      }),
      transformResponse: (response: ISeoTranslationResponse, meta, arg) => response
    })
  })
});

export const RealEstateQueryServicesRf = mainSplitApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    checkConflicts: query<
      IPropertyCheckConflictResponse,
      CheckConflictsRealestateValuesQRTK
    >({
      query: values => ({
        url: RealEstateEndpoints.CheckConflict,
        method: "GET",
        params: values.query
      }),
      transformResponse: (res: IPropertyCheckConflictResponse) =>
        transformPropertyCheckConflict(res),
      providesTags: [PROPERTY_TAG_TYPES.PROPERTY_CHECK_CONFLICT]
    }),

    getTrustEntities: query<TrustEntitiesResponse, GETTrustRealEstateValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.GetTrustEntities,
        method: "GET",
        params: values.query
      }),
      providesTags: [PROPERTY_TAG_TYPES.PROPERTY_TRUST]
    }),

    getDetailProperty: query<IPropertyDetailsResponse, RealEstateDetailsValuesRTKQ>({
      query: values => ({
        url: RealEstateEndpoints.DetailRealEstate(values.params.id),
        method: "GET",
        params: values.query
      }),
      transformResponse: (response: IPropertyDetailsResponse) =>
        remaxGlobalDetailMock(response),
      providesTags: (result, error, arg) => [
        { type: PROPERTY_TAG_TYPES.PROPERTY_DETAIL, id: arg.params.id }
      ]
    }),

    createProperty: mutation<IPropertyDetailsResponse, CreateRealestateValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.CreateRealEstateV3,
        method: "POST",
        body: HGetFormData(values.body)
      }),
      transformResponse: (response: IPropertyDetailsResponse) => response,
      invalidatesTags: [
        PROPERTY_TAG_TYPES.PROPERTY_DETAIL,
        STATS_TAG_TYPES.STATS_GET // Invalidar stats cuando se crea una propiedad
      ]
    }),

    updateRealEstate: mutation<IPropertyDetailsResponse, UpdateRealestateValuesQRTK>(
      {
        query: values => ({
          url: RealEstateEndpoints.UpdateRealEstateV3(values.params.id),
          method: "POST",
          body: HGetFormData(values.body)
        }),
        transformResponse: (response: IPropertyDetailsResponse) => response,
        invalidatesTags: (result, error, values) =>
          error
            ? []
            : [{ type: PROPERTY_TAG_TYPES.PROPERTY_DETAIL, id: values.params.id }]
      }
    ),

    DeleteRealEstateDraft: mutation<any, DeleteDraftRealEstateValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.Draft,
        method: "DELETE",
        params: values.query
      }),
      transformResponse: (response: any) => response,
      invalidatesTags: [STATS_TAG_TYPES.STATS_GET] // Invalidar stats cuando se elimina un borrador
    }),
    GetRealEstateDraft: query<draftResponses, GetDraftRealEstateValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.Draft,
        method: "GET",
        params: values.query
      }),
      providesTags: [PROPERTY_TAG_TYPES.PROPERTY_DETAIL_DRAFT]
    }),
    GetFeatureProperty: query<FeatureResponse, FeatureListValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.GetRealEstateFeatures(values.params.id),
        method: "GET",
        params: values.query
      }),
      providesTags: [PROPERTY_TAG_TYPES.PROPERTY_FEATURE]
    }),
    getPropertyList: query<PropertyListResponse, RealEstateListValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.ListRealEstate,
        method: "GET",
        params: values.query
      }),
      transformResponse: (response: PropertyListResponse) => {
        return {
          ...response,
          data: remaxGlobalListMock(response.data)
        };
      },
      providesTags: [PROPERTY_TAG_TYPES.PROPERTY_LIST]
    }),
    DropProperty: mutation<any, DropRealestateValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.DropRealEstate(values.params.id),
        method: "POST",
        body: getFormData(values.body)
      }),
      transformResponse: (response: any) => response,
      invalidatesTags: (result, error, values) => [
        PROPERTY_TAG_TYPES.PROPERTY_LIST,
        { type: PROPERTY_TAG_TYPES.PROPERTY_DETAIL, id: values.params.id }
      ]
    }),
    ReferProperty: mutation<any, RefererRealestateValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.RefererProperty,
        method: "POST",
        body: values.body
      })
    }),
    ActivateProperty: mutation<any, ActivateRealestateValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.ActivateRealEstate(values.params.id),
        method: "POST",
        body: getFormData(values.body)
      }),
      invalidatesTags: (result, error, values) => [
        PROPERTY_TAG_TYPES.PROPERTY_LIST,
        { type: PROPERTY_TAG_TYPES.PROPERTY_DETAIL, id: values.params.id }
      ]
    }),
    GetPropertyDetail: query<IPropertyDetailsResponse, RealEstateDetailsValuesRTKQ>({
      query: values => ({
        url: RealEstateEndpoints.DetailRealEstate(values.params.id),
        method: "GET",
        params: values.query
      }),
      transformResponse: (response: IPropertyDetailsResponse) => response,
      providesTags: (result, error, arg) => [
        { type: PROPERTY_TAG_TYPES.PROPERTY_DETAIL, id: arg.params.id }
      ]
    }),
    sendFeedback: mutation<any, FeedbackRealestateValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.SendFeedback,
        method: "POST",
        body: values.body
      })
    }),
    resolveConflicts: mutation<any, any>({
      query: values => ({
        url: RealEstateEndpoints.SolveConflict,
        method: "POST",
        body: values.body
      }),
      invalidatesTags: [PROPERTY_TAG_TYPES.PROPERTY_DETAIL]
    }),
    getLastChangeLog: query<
      RealEstateChangeLogResponseRTKQ,
      RealEstateChangeLogValuesRTKQ
    >({
      query: values => ({
        url: RealEstateEndpoints.LastChanges(values.params.id),
        method: "GET",
        params: values.query
      }),
      providesTags: [PROPERTY_TAG_TYPES.PROPERTY_CHANGE_LOG]
    }),
    partialActivateProperty: mutation<any, PartialActivateRealestateValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.partialActivateRealEstate(values.params.id),
        method: "POST"
      }),
      invalidatesTags: (result, error, values) => [
        { type: PROPERTY_TAG_TYPES.PROPERTY_DETAIL, id: values.params.id }
      ]
    }),

    // Send activation request (email + last-request date)
    sendActivationRequest: mutation<any, ActivationRequestRealestateValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.ActivationRequest(values.params.id),
        method: "POST"
      }),
      invalidatesTags: []
    }),

    uploadImage: mutation<IUploadImageResponse, UploadImageValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.UploadImage,
        method: "POST",
        body: HGetFormData(values.body)
      }),
      transformResponse: (response: IUploadImageResponse) => response,
      invalidatesTags: [PROPERTY_TAG_TYPES.PROPERTY_DETAIL]
    }),

    uploadDocument: mutation<IUploadDocumentResponse, UploadDocumentValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.UploadDocument,
        method: "POST",
        body: HGetFormData(values.body)
      }),
      transformResponse: (response: IUploadDocumentResponse) => response,
      invalidatesTags: [PROPERTY_TAG_TYPES.PROPERTY_DETAIL]
    }),

    // v3 endpoints for edit mode (by realestate id)
    uploadImageById: mutation<
      IUploadImageByIdResponse & { url?: string; id?: number | string },
      UploadImageByIdValuesQRTK
    >({
      query: values => ({
        url: RealEstateEndpoints.UploadImageById(values.params.id),
        method: "POST",
        body: HGetFormData(values.body)
      }),
      transformResponse: (response: IUploadImageByIdResponse & any) => {
        const url = response?.data?.path ?? response?.data?.filename ?? "";
        if (url) {
          return {
            ...response,
            url,
            id: response?.data?.id
          };
        }
        return response;
      },
      invalidatesTags: []
    }),
    uploadDocumentById: mutation<
      IUploadDocumentByIdResponse & { url?: string; id?: number | string },
      UploadDocumentByIdValuesQRTK
    >({
      query: values => ({
        url: RealEstateEndpoints.UploadDocumentById(values.params.id),
        method: "POST",
        body: HGetFormData(values.body)
      }),
      transformResponse: (response: IUploadDocumentByIdResponse) => {
        const url = response?.data?.filename ?? response?.data?.path ?? "";
        if (url) {
          return {
            ...response,
            url: url,
            id: response?.data?.id
          };
        }
        return response;
      },
      invalidatesTags: []
    }),
    deleteImageById: mutation<
      any,
      { params: { id: string | number; imageId: string | number } }
    >({
      query: values => ({
        url: RealEstateEndpoints.DeleteImageById(
          values.params.id,
          values.params.imageId
        ),
        method: "DELETE"
      }),
      transformResponse: (response: any) => response,
      invalidatesTags: []
    }),

    GenerateSeoWithChatGpt: mutation<
      IGenerateSeoWithChatGptResponse,
      GenerateSeoWithChatGptValuesQRTK
    >({
      query: values => ({
        url: RealEstateEndpoints.generateSeoWithChatGpt,
        method: "POST",
        body: values.body
      }),
      transformResponse: (response: IGenerateSeoWithChatGptResponse) => response
    }),

    // New: translate SEO v3 (JSON body)
    translateSeoV3: mutation<ITranslationV3Response, TranslationV3ValuesQRTK>({
      query: values => ({
        url: RealEstateEndpoints.TranslationV3,
        method: "POST",
        body: values.body
      }),
      transformResponse: (
        response: any,
        meta,
        arg: TranslationV3ValuesQRTK
      ): ITranslationV3Response => {
        const flat = response as { title?: string; description?: string };
        const target = arg?.body?.target_lang;

        if (target === "en") {
          return {
            en: {
              title: flat?.title ?? "",
              description: flat?.description ?? ""
            }
          };
        }
        if (target === "es") {
          return {
            es: {
              title: flat?.title ?? "",
              description: flat?.description ?? ""
            }
          };
        }
        return response as ITranslationV3Response;
      }
    }),
    ApproveDocument: mutation({
      query: (values: ApproveRealestateValuesQRTK) => ({
        url: RealEstateEndpoints.approveDocument(),
        method: "POST",
        body: getFormData(values.body)
      }),
      transformResponse: (response: any, meta, arg) => response,
      invalidatesTags: (result, error, values) =>
        error ? [] : [PROPERTY_TAG_TYPES.PROPERTY_DETAIL]
    }),

    DeclineDocument: mutation({
      query: (values: DeclineRealestateValuesQRTK) => ({
        url: RealEstateEndpoints.declineDocument(),
        method: "POST",
        body: getFormData(values.body)
      }),
      transformResponse: (response: any, meta, arg) => response,
      invalidatesTags: (result, error, values) =>
        error ? [] : [PROPERTY_TAG_TYPES.PROPERTY_DETAIL]
    })
  })
});

export const {
  useLazyCheckConflictsQuery,
  useCreatePropertyMutation,
  useUpdateRealEstateMutation,
  useGetRealEstateDraftQuery,
  useDeleteRealEstateDraftMutation,
  useLazyGetRealEstateDraftQuery,
  useGetDetailPropertyQuery,
  useLazyGetDetailPropertyQuery,
  useGetTrustEntitiesQuery,
  useGetFeaturePropertyQuery,
  useLazyGetFeaturePropertyQuery,
  useGetPropertyListQuery,
  useLazyGetPropertyListQuery,
  useDropPropertyMutation,
  useReferPropertyMutation,
  useActivatePropertyMutation,
  useSendFeedbackMutation,
  useResolveConflictsMutation,
  useGetLastChangeLogQuery,
  useLazyGetLastChangeLogQuery,
  usePartialActivatePropertyMutation,
  useUploadImageMutation,
  useUploadDocumentMutation,
  useUploadImageByIdMutation,
  useUploadDocumentByIdMutation,
  useDeleteImageByIdMutation,
  useGenerateSeoWithChatGptMutation,
  useTranslateSeoV3Mutation,
  useSendActivationRequestMutation,
  useApproveDocumentMutation,
  useDeclineDocumentMutation
} = RealEstateQueryServicesRf;

export const {
  useGetFeatureProjectMutation,
  useGetFeatureMutation,
  usePropertyListMutation,
  useRefererPropertyMutation,
  useDeleteRealEstateMutation,
  useDropRealEstateMutation,
  useLastChangesRealEstateMutation,
  useGetSeoWithChatGptMutation,
  useReportRealEstateMutation,
  useGetConflictsMutation,
  useSolveConflictsMutation,
  useSedFeedbackMutation,
  useGetAdvanceDataMutation,
  useGetTrustEntitiesMutation,
  useTranslateSeoMutation
} = RealEstateQueryServices;
